import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { ArithmeglyphsStore } from '../ArithmeglyphsStore';
import InstructionsDialog from '../../../InstructionsDialog';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Page1, Page2, Page3, Page4 } from './InstructionsPages';
import { PuzzleNames } from '../../../../utils/types';
import { DOMAIN } from '../../shared/utils';
import './Instructions.less';

export const DotNavigation = ({ numDots, page, onDotClick }: { numDots: number, page: number, onDotClick: (i: number) => void }) => {
  return (
    <div className="dotContainer">
      {[0, 1, 2, 3].map(index => (
        <div
          key={index}
          className={`dot ${page === index ? 'active' : ''}`}
          onClick={() => onDotClick(index)}
        ></div>
      ))}
    </div>
  );
};

const Instructions = () => {
  const instructionsAreOpen = ArithmeglyphsStore.useState(s => s.instructionsAreOpen);
  const [page, setPage] = useState(0);

  const closeInstructions = () => {
    ArithmeglyphsStore.update(s => {
      s.instructionsAreOpen = false;
      s.isSoftPaused = false;
    });
    Cookies.set(`${PuzzleNames.Arithmeglyphs}InstructionsDismissed`, 'true', {
      domain: DOMAIN,
      expires: 365,
    });
    setTimeout(() => setPage(0), 100);
  };

  const nextPage = () => {
    if (page < 3) setPage(page + 1);
  };

  const prevPage = () => {
    if (page > 0) setPage(page - 1);
  };

  return (
    <InstructionsDialog
      isOpen={instructionsAreOpen}
      onClose={closeInstructions}
      className="arithmeglyphsInstructions"
    >
      <h1 className="instructionsTitle">How to Play Arithmeglyphs</h1>
      <div className="pages" style={{ transform: `translateX(-${page * 25}%)` }}>
        <Page1/>
        <Page2/>
        <Page3/>
        <Page4/>
      </div>
      <div className="navigation">
        <button onClick={prevPage} disabled={page === 0}>
          <ArrowBackIosIcon/>
        </button>
        <DotNavigation numDots={4} page={page} onDotClick={(i: number) => {
          setPage(i);
        }}/>
        <button onClick={nextPage} disabled={page === 3}>
          <ArrowForwardIosIcon/>
        </button>
      </div>
    </InstructionsDialog>
  );
};

export default Instructions;